export const styles = {
  navbarStaticTop: {
    height: 80,
    fontFamily: '"Nunito", sans-serif',
    display: 'none',
    zIndex: 1
  },
  visible: {
    display: 'inherit'
  },
  sticky: {
    position: 'sticky',
    top: 0,
    marginTop: -80
  },
  whitebackground: {
    background: 'white'
  },
  brand: {
    marginLeft: 16
  },
  leftItems: {
    display: 'flex',
    flexDirection: 'row'
  },
  rightItems: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    width: '100%',
    marginRight: 20
  },
  navbarExpanded: {
    display: 'flex',
    flexDirection: 'row',
    'z-index': 1,
    overflow: 'visible',
    height: 80,
    alignItems: 'center'
  },
  login: {
    border: '2px solid white',
    borderRadius: 5,
    lineHeight: '40px',
    color: 'white',
    padding: '0 30px',
    textDecoration: 'none',
    '&:hover': {
      background: 'rgba(255,255,255,0.2)'
    }
  },
  darkoutline: {
    borderColor: '#2F3755',
    color: '#2F3755',
    '&:hover': {
      background: 'rgba(47,55,83,0.2)'
    }
  },
  '@media (max-width: 767px)': {
    brand: {
      '& > img': {
        height: '40px'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Styles/Navbar.Style.js